function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { styled } from 'styled-components';
const StyledAnchor = styled.a.withConfig({
  componentId: "aui__sc-z9bgpq-0"
})(["color:inherit;text-decoration:underline;&:hover{text-decoration:none;}"]);

// comment to kickstart release

export const Inline = /*#__PURE__*/React.forwardRef(({
  children,
  actionRef,
  ...props
}, fref) => /*#__PURE__*/React.createElement(StyledAnchor, _extends({
  "data-aui": "action.inline"
}, props, {
  ref: fref || actionRef
}), children));